import React from 'react'
import { TerminalError } from '@components'
import { Button } from 'antd'

const ServerError = () => (
  <TerminalError
    title='Oops! Something went wrong'
    message='An error has occured. Please try again or contact our customer services team.'
    extra={
      <Button href='/' type='primary' size='large' shape='round'>
        Take me Home
      </Button>
    }
  />
)

export default ServerError
